//@flow
import React from "react";
//$FlowFixMe
import css from "./radioplayer.module.scss";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faAngleDoubleRight } from "@fortawesome/free-solid-svg-icons";

type Props = {
  children?: string,
  title: string,
  colour:string
};

class Heading extends React.PureComponent<Props, *> {
  render(): Object {
    return (
      <div className={css.heading}>
        <div className={css.headingTitle}>
          <div className={css.headingIcon} style={{backgroundColor:this.props.colour}}></div>
          <div className={css.headingTitleText}>{this.props.title}</div>
        </div>
        <div className={css.headingInfoText}>{this.props.children}</div>
      </div>
    );
  }
}
export default Heading;
